import BaseModel from './base';
import UserDuplicateMerge from './user-duplicate-merge';
import UserDuplicateMember from './user-duplicate-member';
import { USER_DUPLICATE_MAP } from '@/modules/UserDuplicatesMerges/components/constants';

export default class UserDuplicate extends BaseModel {
  constructor(userDuplicate, url) {
    super(userDuplicate, url);

    this.id = userDuplicate.id;
    this.first_user_id = userDuplicate.first_user_id;
    this.second_user_id = userDuplicate.second_user_id;
    this.status = USER_DUPLICATE_MAP[userDuplicate.status];
    this.is_available_email_merge = userDuplicate.is_available_email_merge;
    this.is_available_vk_merge = userDuplicate.is_available_vk_merge;
    this.is_available_apple_merge = userDuplicate.is_available_apple_merge;
    this.is_available_telegram_merge = userDuplicate.is_available_telegram_merge;
    this.user_duplicate_merges = userDuplicate?.user_duplicate_merges
      ? userDuplicate.user_duplicate_merges.map((userDuplicateMerge) => new UserDuplicateMerge(userDuplicateMerge))
      : [];
    this.other_user = userDuplicate?.other_user ? new UserDuplicateMember(userDuplicate.other_user) : null;
  }
}
